<template>
  <div class="page-container">
    <el-card shadow="never">
      <!-- 状态Tab -->
      <div class="status-tabs">
        <el-tabs v-model="query.status" @tab-click="handleTabClick">
          <el-tab-pane v-for="tab in statusTabs" :key="tab.name" :label="tab.label" :name="tab.name" />
        </el-tabs>
      </div>

      <div class="toolbar">
        <div class="toolbar-left">
          <el-input
            v-model="query.orderNo"
            placeholder="订单编号"
            prefix-icon="el-icon-search"
            clearable
            size="small"
            style="width: 180px; margin-right: 12px;"
            @keyup.enter.native="handleSearch"
            @clear="handleSearch"
          />
          <el-input
            v-model="query.tenantName"
            placeholder="客户姓名"
            prefix-icon="el-icon-user"
            clearable
            size="small"
            style="width: 140px; margin-right: 12px;"
            @keyup.enter.native="handleSearch"
            @clear="handleSearch"
          />
          <el-input
            v-model="query.tenantPhone"
            placeholder="手机号码"
            prefix-icon="el-icon-phone"
            clearable
            size="small"
            style="width: 160px; margin-right: 12px;"
            @keyup.enter.native="handleSearch"
            @clear="handleSearch"
          />
          <el-input
            v-model="query.tenantIdCard"
            placeholder="身份证号"
            prefix-icon="el-icon-document"
            clearable
            size="small"
            style="width: 180px; margin-right: 12px;"
            @keyup.enter.native="handleSearch"
            @clear="handleSearch"
          />
          <el-date-picker
            v-model="query.dateRange"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            size="small"
            style="margin-right: 12px;"
            value-format="yyyy-MM-dd"
            @change="handleSearch"
          />
          <el-button type="primary" size="small" icon="el-icon-search" @click="handleSearch">
            搜索
          </el-button>
          <el-button size="small" icon="el-icon-refresh" @click="handleReset">
            重置
          </el-button>
        </div>
      </div>

      <el-table
        :data="tableData"
        v-loading="loading"
        border
        stripe
        style="width: 100%; margin-top: 16px;"
      >
        <el-table-column prop="orderNo" label="订单编号" width="180" show-overflow-tooltip />
        <el-table-column prop="shopName" label="商户名称" min-width="120" show-overflow-tooltip />
	        <el-table-column prop="goodsName" label="商品名称" min-width="140" show-overflow-tooltip>
	          <template slot-scope="scope">
	            <el-tag size="mini" :type="scope.row.rentType === 'LONG' ? 'danger' : 'info'" style="margin-right:4px;">{{ scope.row.rentType === 'LONG' ? '长租' : (scope.row.rentType === 'SHORT' ? '短租' : '-') }}</el-tag>{{ scope.row.goodsName }}
	            <span style="font-size:12px;color:#909399;margin-left:4px;" v-if="scope.row.quantity">x{{ scope.row.quantity }}</span>
	          </template>
	        </el-table-column>
	        <el-table-column prop="tenantName" label="客户姓名" width="90" align="center" />
	        <el-table-column prop="tenantPhone" label="手机号" width="120" align="center" />
        <el-table-column prop="orderPrice" label="订单金额" width="110" align="center">
          <template slot-scope="scope">
            ¥{{ scope.row.orderPrice }}
          </template>
        </el-table-column>
        <el-table-column prop="rentDays" label="租期(天)" width="90" align="center" />
	        <el-table-column prop="status" label="订单状态" width="100" align="center">
          <template slot-scope="scope">
            <el-tag :type="getStatusType(scope.row.status)" size="small">
              {{ getStatusText(scope.row.status) }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="createdAt" label="创建时间" width="160" />
        <el-table-column label="基础操作" width="200" fixed="right" align="center">
          <template slot-scope="scope">
            <el-button type="text" size="small" @click="handleDetail(scope.row)">
              详情
            </el-button>
            <el-button type="text" size="small" @click="handleRentPeriod(scope.row)">
              租期
            </el-button>
            <el-button
              type="text"
              size="small"
              style="color: #E6A23C;"
              @click="handleRiskConsult(scope.row)"
            >
              风控
            </el-button>
          </template>
        </el-table-column>
        <el-table-column label="流程相关操作" width="230" fixed="right" align="center" v-if="!isPlatformAdmin">
          <template slot="header">
            <span>流程相关操作</span>
            <el-tooltip content="点击查看订单流程流转说明" placement="top">
              <el-button
                type="text"
                size="mini"
                icon="el-icon-question"
                style="color: #409EFF; padding: 0; vertical-align: middle; margin-left: 4px;"
                @click="flowDescVisible = true"
              />
            </el-tooltip>
          </template>
          <template slot-scope="scope">
            <el-button
              v-if="scope.row.status === 'WAIT_APPROVE'"
              type="text"
              size="small"
              style="color: #67C23A; font-weight: 500;"
              @click="handleAction(scope.row, 'approve')"
            >
              审核通过
            </el-button>
            <el-tag
              v-if="scope.row.status === 'WAIT_CONTRACT'"
              size="small"
              type="warning"
              effect="plain"
            >
              合同签署中
            </el-tag>
            <el-button
              v-if="scope.row.status === 'WAIT_CONTRACT'"
            <el-button
              v-if="scope.row.status === 'APPROVED'"
              type="text"
              size="small"
              style="color: #409EFF; font-weight: 500;"
              @click="handleAction(scope.row, 'deliver')"
            >
              发货
            </el-button>
            <el-button
              v-if="scope.row.status === 'DELIVERED'"
              type="text"
              size="small"
              style="color: #67C23A; font-weight: 500;"
              @click="handleAction(scope.row, 'receive')"
            >
              确认收货
            </el-button>
            <el-button
              v-if="canReturn(scope.row)"
              type="text"
              size="small"
              style="color: #E6A23C; font-weight: 500;"
              @click="handleReturn(scope.row)"
            >
              用户寄回
            </el-button>
            <el-button
              v-if="canReceiveReturn(scope.row.status)"
              type="text"
              size="small"
              style="color: #409EFF; font-weight: 500;"
              @click="handleReceiveReturn(scope.row)"
            >
              确认归还
            </el-button>
            <el-button
              v-if="canFinish(scope.row.status)"
              type="text"
              size="small"
              style="color: #67C23A; font-weight: 500;"
              @click="handleFinish(scope.row)"
            >
              完成
            </el-button>
            <el-button
              v-if="canCancel(scope.row.status)"
              type="text"
              size="small"
              style="color: #F56C6C; font-weight: 500;"
              @click="handleAction(scope.row, 'cancel')"
            >
              取消
            </el-button>
          </template>
        </el-table-column>
      </el-table>

      <div class="pagination-wrapper">
        <el-pagination
          background
          layout="total, prev, pager, next"
          :total="total"
          :page-size="pageSize"
          :current-page.sync="currentPage"
          @current-change="loadData"
        />
      </div>
    </el-card>

    <el-dialog title="订单发货" :visible.sync="deliverVisible" width="520px" :close-on-click-modal="false">
      <el-form ref="deliverFormRef" :model="deliverForm" label-width="96px" label-position="right">
        <el-form-item label="发货方式" required>
          <el-radio-group v-model="deliverForm.deliveryType">
            <el-radio label="SELFPICK">
              <i class="el-icon-location-outline" />
              <span>到店自提</span>
            </el-radio>
            <el-radio label="EXPRESS">
              <i class="el-icon-s-promotion" />
              <span>快递发货</span>
            </el-radio>
            <el-radio label="INTRA_CITY_EXPRESS">
              <i class="el-icon-s-cooperation" />
              <span>同城配送</span>
            </el-radio>
          </el-radio-group>
        </el-form-item>

        <template v-if="deliverForm.deliveryType === 'EXPRESS'">
          <el-form-item label="快递公司" required>
            <el-select
              v-model="deliverForm.deliveryCompany"
              placeholder="请选择快递公司"
              filterable
              style="width: 100%"
            >
              <el-option
                v-for="c in expressCompanies"
                :key="c.id"
                :label="c.name"
                :value="c.id"
              />
            </el-select>
          </el-form-item>
          <el-form-item label="快递单号" required>
            <el-input
              v-model="deliverForm.waybillId"
              placeholder="请输入快递单号"
              clearable
            />
          </el-form-item>
        </template>

        <template v-else-if="deliverForm.deliveryType === 'INTRA_CITY_EXPRESS'">
          <el-form-item label="配送说明">
            <el-input
              v-model="deliverForm.comment"
              type="textarea"
              :rows="2"
              placeholder="可填写配送备注（可选）"
            />
          </el-form-item>
        </template>

        <el-form-item v-if="deliverForm.deliveryType === 'SELFPICK'" label=" ">
          <el-alert
            title="用户到店自提，无需填写物流信息"
            type="info"
            show-icon
            :closable="false"
            style="width: 100%;"
          />
        </el-form-item>
      </el-form>

      <div slot="footer">
        <el-button @click="deliverVisible = false">取 消</el-button>
        <el-button type="primary" :loading="submitting" @click="confirmDeliver">
          确认发货
        </el-button>
      </div>
    </el-dialog>

    <el-dialog title="租期信息" :visible.sync="rentPeriodVisible" width="1050px" @close="onRentPeriodClose">
      <div style="margin-bottom: 12px; color: #606266;">
        订单 <b style="color: #409EFF;">{{ rentPeriodOrder ? rentPeriodOrder.orderNo : '' }}</b>
        <span v-if="rentPeriodOrder" style="margin-left: 12px;">商品: {{ rentPeriodOrder.goodsName }}</span>
        <span v-if="rentPeriodOrder" style="margin-left: 12px;">金额: ¥{{ rentPeriodOrder.orderPrice }}</span>
      </div>

      <el-table :data="installmentData" v-loading="installmentLoading" size="small" border stripe row-key="installmentNo">
        <el-table-column prop="installmentNo" label="期数" width="65" align="center">
          <template slot-scope="scope">
            <el-tag size="mini">第{{ scope.row.installmentNo }}/共{{ installmentData.length }}期</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="installmentPrice" label="本期租金" width="120" align="center">
          <template slot-scope="scope">
            ¥{{ scope.row.installmentPrice }}
          </template>
        </el-table-column>
        <el-table-column prop="planPayTime" label="计划扣款日" width="170">
          <template slot-scope="scope">
            {{ formatTime(scope.row.planPayTime) }}
          </template>
        </el-table-column>
        <el-table-column prop="status" label="状态" width="100" align="center">
          <template slot-scope="scope">
            <el-tag size="mini" :type="instStatusTag(scope.row.status)">
              {{ instStatusText(scope.row.status) }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="paidAmount" label="已付金额" width="110" align="center">
          <template slot-scope="scope">
            ¥{{ scope.row.paidAmount || '0.00' }}
          </template>
        </el-table-column>
        <el-table-column label="操作" min-width="300" align="center">
          <template slot-scope="scope">
            <el-button
              type="primary"
              size="mini"
              :loading="scope.row._deducting"
              :disabled="scope.row.status === 'PAID'"
              @click="handleDeductClick(scope.row)"
            >
              {{ scope.row._deducting ? '扣款中...' : '租金扣款' }}
            </el-button>
            <el-button
              type="warning"
              size="mini"
              :disabled="scope.row.status === 'PAID'"
              @click="handleOfflinePayClick(scope.row)"
            >
              线下付租
            </el-button>
            <el-button
              type="info"
              size="mini"
              @click="handleDeductionRecords(scope.row)"
            >
              扣款记录 <span v-if="scope.row.deductionRecords && scope.row.deductionRecords.length">({{ scope.row.deductionRecords.length }})</span>
            </el-button>
          </template>
        </el-table-column>
      </el-table>

      <div slot="footer">
        <el-button @click="rentPeriodVisible = false">关 闭</el-button>
      </div>
    </el-dialog>

    <!-- 线下付租弹窗 -->
    <el-dialog title="线下付租" :visible.sync="offlinePayVisible" width="480px" append-to-body>
      <el-form :model="offlinePayForm" label-width="100px" size="small">
        <el-form-item label="分期">
          <el-tag type="warning">第{{ offlinePayForm.installmentNo }}/共{{ installmentData.length }}期</el-tag>
        </el-form-item>
        <el-form-item label="支付金额(元)" required>
          <el-input-number v-model="offlinePayForm.amount" :min="0" :precision="2" style="width: 100%;" />
        </el-form-item>
        <el-form-item label="支付渠道" required>
          <el-select v-model="offlinePayForm.payChannel" style="width: 100%;">
            <el-option label="支付宝" value="ALIPAY" />
            <el-option label="微信支付" value="WECHAT" />
            <el-option label="其他渠道" value="OTHER" />
          </el-select>
        </el-form-item>
        <el-form-item label="支付单号" v-if="offlinePayForm.payChannel === 'ALIPAY'">
          <el-input v-model="offlinePayForm.tradeNo" placeholder="支付宝交易号（必填）" />
        </el-form-item>
        <el-form-item label="支付单号" v-if="offlinePayForm.payChannel !== 'ALIPAY'">
          <el-input v-model="offlinePayForm.tradeNo" placeholder="对应支付渠道的单号（可选）" />
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="offlinePayVisible = false">取 消</el-button>
        <el-button type="primary" :loading="offlinePaySubmitting" @click="confirmOfflinePay">
          确认同步
        </el-button>
      </div>
    </el-dialog>

    <!-- 扣款记录弹窗 -->
    <el-dialog :title="`扣款记录 · 第${deductionInstNo}/共${installmentData.length}期`" :visible.sync="deductionRecordVisible" width="750px" append-to-body>
      <el-table :data="deductionRecordData" v-loading="deductionRecordLoading" size="small" border stripe height="360">
        <el-table-column label="扣款时间" width="155">
          <template slot-scope="scope">
            {{ scope.row.createdAt ? formatRiskTime(scope.row.createdAt) : '-' }}
          </template>
        </el-table-column>
        <el-table-column label="外部请求号" width="200" show-overflow-tooltip prop="outTradeNo" />
        <el-table-column label="支付宝交易号" width="220" show-overflow-tooltip prop="tradeNo" />
        <el-table-column label="支付方式" width="95" align="center">
          <template slot-scope="scope">
            <el-tag size="mini" :type="payMethodTag(scope.row.payMethod)">
              {{ payMethodText(scope.row.payMethod) }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column label="金额" width="100" align="center">
          <template slot-scope="scope">
            ¥{{ scope.row.payAmount || '0.00' }}
          </template>
        </el-table-column>
        <el-table-column label="状态" width="80" align="center">
          <template slot-scope="scope">
            <el-tag size="mini" :type="payStatusTag(scope.row.status)">
              {{ payStatusText(scope.row.status) }}
            </el-tag>
          </template>
        </el-table-column>
      </el-table>
      <div slot="footer">
        <el-button @click="deductionRecordVisible = false">关 闭</el-button>
      </div>
    </el-dialog>

    <el-dialog title="风控详情" :visible.sync="riskVisible" width="1080px" :close-on-click-modal="true" @close="onRiskDialogClose">
      <div style="margin-bottom: 12px; display: flex; justify-content: space-between; align-items: center;">
        <div style="color: #606266;">
          订单 <b style="color: #409EFF;">{{ riskOrder ? riskOrder.orderNo : '' }}</b>
          <span v-if="riskHistory.length" style="color: #909399; margin-left: 8px;">（共 {{ riskHistory.length }} 条记录）</span>
        </div>
        <div style="display: flex; align-items: center; gap: 8px;">
          <el-select v-model="selectedRiskTypes" multiple placeholder="选择风控类型" size="small" style="width: 280px;">
            <el-option label="共租风险（专业版）" value="CONCURRENT_RENT_PRO"></el-option>
            <el-option label="综合风险等级" value="COMPREHENSIVE_RISK"></el-option>
            <el-option label="发货建议" value="SHIP_GOODS_RISK"></el-option>
            <el-option label="垂直租赁风险" value="VERTICAL_RENT_RISK"></el-option>
          </el-select>
          <el-button
            v-if="riskOrder && riskOrder.signStatus === 'SIGNED'"
            type="success"
            size="small"
            :loading="legalLoading"
            @click="doLegalConsult"
          >
            {{ legalLoading ? '查询中...' : '发起人法查询' }}
          </el-button>
          <el-button
            v-if="riskOrder && riskOrder.signStatus === 'SIGNED'"
            type="warning"
            size="small"
            :loading="creditLoading"
            @click="doCreditConsult"
          >
            {{ creditLoading ? '查询中...' : '发起征信查询' }}
          </el-button>
          <el-button
            v-if="riskOrder && riskOrder.signStatus === 'SIGNED'"
            size="small"
            :loading="zuxianzhiLoading"
            @click="doZuxianzhiConsult"
          >
            {{ zuxianzhiLoading ? '查询中...' : '发起租先知查询' }}
          </el-button>
          <el-button type="primary" size="small" :loading="riskLoading" @click="doRiskConsult">
            {{ riskLoading ? '咨询中...' : '+ 新增风控咨询' }}
          </el-button>
        </div>
      </div>

      <el-row :gutter="12" v-if="riskOrder">
        <el-col :span="12">
          <div style="border: 1px solid #EBEEF5; border-radius: 6px; padding: 12px;">
            <div style="font-weight: 600; margin-bottom: 8px; color: #303133; border-left: 3px solid #409EFF; padding-left: 8px;">订单概要</div>
            <el-descriptions :column="1" size="small" border>
              <el-descriptions-item label="订单标题">{{ riskOrder.title || '-' }}</el-descriptions-item>
              <el-descriptions-item label="商品">{{ riskOrder.goodsName || '-' }}</el-descriptions-item>
              <el-descriptions-item label="状态">
                <el-tag size="mini" :type="getStatusType(riskOrder.status)">{{ getStatusText(riskOrder.status) }}</el-tag>
              </el-descriptions-item>
              <el-descriptions-item label="租金">¥{{ riskOrder.orderPrice || '0.00' }}</el-descriptions-item>
              <el-descriptions-item label="押金">¥{{ riskOrder.depositPrice || '0.00' }}</el-descriptions-item>
              <el-descriptions-item label="签约">{{ riskOrder.signStatus || '-' }} / {{ riskOrder.signType || '-' }}</el-descriptions-item>
              <el-descriptions-item label="支付宝订单号">
                <span v-if="riskOrder.alipayOrderId" style="font-size: 12px;">{{ riskOrder.alipayOrderId }}</span>
                <span v-else>-</span>
              </el-descriptions-item>
            </el-descriptions>
          </div>
        </el-col>
        <el-col :span="12">
          <div style="border: 1px solid #EBEEF5; border-radius: 6px; padding: 12px;">
            <div style="font-weight: 600; margin-bottom: 8px; color: #303133; border-left: 3px solid #67C23A; padding-left: 8px;">用户概要</div>
            <el-descriptions :column="1" size="small" border>
              <el-descriptions-item label="租户姓名">{{ riskOrder.tenantName || '-' }}</el-descriptions-item>
              <el-descriptions-item label="租户手机号">{{ riskOrder.tenantPhone || '-' }}</el-descriptions-item>
              <el-descriptions-item label="租户身份证">
                <span v-if="riskOrder.tenantIdCard" style="font-size: 12px; letter-spacing: 0.5px;">{{ riskOrder.tenantIdCard }}</span>
                <span v-else>-</span>
              </el-descriptions-item>
              <el-descriptions-item label="openId">
                <span v-if="riskOrder.alipayOpenId" style="font-size: 12px;">{{ riskOrder.alipayOpenId }}</span>
                <span v-else>-</span>
              </el-descriptions-item>
            </el-descriptions>
          </div>
        </el-col>
      </el-row>

      <div style="margin-top: 16px;">
        <div style="font-weight: 600; margin-bottom: 8px; color: #303133; border-left: 3px solid #E6A23C; padding-left: 8px;">风控详情（租安盾历史咨询）</div>
        <el-table :data="riskHistory" v-loading="riskLoading" size="small" border stripe row-key="id" max-height="420">

        <el-table-column type="expand">
          <template slot-scope="scope">
            <div class="risk-expand-wrap">
              <div class="risk-expand-section">
                <div class="risk-expand-title">基础信息 (Basic Info)</div>
                <el-descriptions :column="2" border size="mini">
                  <el-descriptions-item label="产品版本">
                    {{ productEditionLabel(getRaw(scope.row, 'product_edition')) }}
                    <span v-if="getRaw(scope.row, 'product_edition')" style="color:#909399; font-size:11px;">({{ getRaw(scope.row, 'product_edition') }})</span>
                  </el-descriptions-item>
                  <el-descriptions-item label="联营分组">
                    <template v-if="getRaw(scope.row, 'vam_group')">
                      {{ vamGroupLabel(getRaw(scope.row, 'vam_group')) }}
                      <span style="color:#909399; font-size:11px;">({{ getRaw(scope.row, 'vam_group') }})</span>
                    </template>
                    <template v-else>-</template>
                  </el-descriptions-item>
                  <el-descriptions-item label="风控策略">
                    <template v-if="getBasic(scope.row, 'risk_policy_value')">
                      {{ policyValueLabel(getBasic(scope.row, 'risk_policy_value')) }}
                      <span style="color:#909399; font-size:11px;">({{ getBasic(scope.row, 'risk_policy_value') }})</span>
                    </template>
                    <template v-else>-</template>
                  </el-descriptions-item>
                  <el-descriptions-item label="风控评估ID">{{ getBasic(scope.row, 'risk_scheme_id') || '-' }}</el-descriptions-item>
                </el-descriptions>
              </div>

              <div v-if="getRaw(scope.row, 'risk_infos') && getRaw(scope.row, 'risk_infos').length" class="risk-expand-section">
                <div class="risk-expand-title">风险项 (Risk Infos)</div>
                <div v-for="ri in getRaw(scope.row, 'risk_infos')" :key="ri.risk_type" style="margin-bottom: 6px;">
                  <div style="font-size:12px; color:#303133; font-weight:600; margin-bottom:2px;">
                    {{ riskTypeLabel(ri.risk_type) }} <span style="color:#909399; font-weight:400;">({{ ri.risk_type }})</span>
                  </div>
                  <el-table :data="ri.risk_item_list || []" size="mini" border stripe>
                    <el-table-column prop="risk_code" label="风险编码 (risk_code)" min-width="260">
                      <template slot-scope="s">
                        <div style="font-size:12px;">
                          <div style="font-weight:500;">{{ riskCodeLabel(s.row.risk_code) }}</div>
                          <div style="color:#909399; font-size:11px;">{{ s.row.risk_code }}</div>
                        </div>
                      </template>
                    </el-table-column>
                    <el-table-column prop="risk_level" label="风险等级 (risk_level)" width="180">
                      <template slot-scope="s">
                        <el-tag size="mini" :type="riskItemLevelTag(s.row.risk_level)">{{ riskLevelText(s.row.risk_level) }}</el-tag>
                        <span style="color:#909399; font-size:11px;"> {{ s.row.risk_level }}</span>
                      </template>
                    </el-table-column>
                  </el-table>
                </div>
              </div>

              <div v-if="getVertical(scope.row)" class="risk-expand-section">
                <div class="risk-expand-title">租赁专项风险 (Vertical Risk Models)</div>
                <el-descriptions :column="2" border size="mini">
                  <el-descriptions-item label="中介风险等级 (mediary_risk_level)">
                    <template v-if="getVertical(scope.row, 'mediary_risk_level')">
                      <el-tag size="mini" :type="verticalLevelTag('mediary', getVertical(scope.row, 'mediary_risk_level'))">
                        {{ riskLevelText(getVertical(scope.row, 'mediary_risk_level')) }}
                      </el-tag>
                      <span style="color:#909399; font-size:11px; margin-left:4px;">{{ getVertical(scope.row, 'mediary_risk_level') }}</span>
                    </template>
                    <template v-else>-</template>
                  </el-descriptions-item>
                  <el-descriptions-item label="当前在租等级 (ongoing_rent_level)">
                    <template v-if="getVertical(scope.row, 'ongoing_rent_level')">
                      <el-tag size="mini" :type="verticalLevelTag('ongoing', getVertical(scope.row, 'ongoing_rent_level'))">
                        {{ ongoingLabel(getVertical(scope.row, 'ongoing_rent_level')) }}
                      </el-tag>
                      <span style="color:#909399; font-size:11px; margin-left:4px;">{{ getVertical(scope.row, 'ongoing_rent_level') }}</span>
                    </template>
                    <template v-else>-</template>
                  </el-descriptions-item>
                  <el-descriptions-item label="履约能力等级 (fulfillment_capacity_level)">
                    <template v-if="getVertical(scope.row, 'fulfillment_capacity_level') != null">
                      <el-tag size="mini" :type="verticalLevelTag('fulfillment', getVertical(scope.row, 'fulfillment_capacity_level'))">
                        {{ getVertical(scope.row, 'fulfillment_capacity_level') }} 级
                      </el-tag>
                      <span style="color:#909399; font-size:11px; margin-left:4px;">(0~5，越高越好)</span>
                    </template>
                    <template v-else>-</template>
                  </el-descriptions-item>
                </el-descriptions>
              </div>

              <div v-if="getRaw(scope.row, 'tailored_risk_models') && getRaw(scope.row, 'tailored_risk_models').length" class="risk-expand-section">
                <div class="risk-expand-title">长租定制综合风险等级 (Tailored Risk Models)</div>
                <el-table :data="getRaw(scope.row, 'tailored_risk_models')" size="mini" border stripe>
                  <el-table-column label="风险等级 (tailored_risk_level)" width="200">
                    <template slot-scope="s">
                      <el-tag size="mini" :type="tailoredRiskLevelTag(s.row.tailored_risk_level)">
                        {{ s.row.tailored_risk_level || '-' }}
                      </el-tag>
                      <span style="color:#909399; font-size:11px; margin-left:4px;">(D1~D10)</span>
                    </template>
                  </el-table-column>
                </el-table>
                <div style="font-size:11px; color:#909399; margin-top:4px;">
                  D1~D3: 低风险 · D4~D6: 中风险 · D7~D8: 高风险 · D9~D10: 极高风险
                </div>
              </div>

              <div v-if="getRaw(scope.row, 'comprehensive_risk_models')" class="risk-expand-section">
                <div class="risk-expand-title">综合风险模型 (Comprehensive Risk Models)</div>
                <el-descriptions :column="2" border size="mini">
                  <el-descriptions-item label="风险级别 (risk_level)">
                    <el-tag size="mini" :type="comprehensiveLevelTag(scope.row)">
                      {{ getComprehensive(scope.row, 'risk_level') || '-' }}
                    </el-tag>
                  </el-descriptions-item>
                  <el-descriptions-item label="等级类型 (risk_level_type)">
                    {{ getComprehensive(scope.row, 'risk_level_type') || '-' }}
                    <span v-if="getComprehensive(scope.row, 'risk_level_type') === 'Tn_Level'" style="color:#909399; font-size:11px;">(T1~T10)</span>
                    <span v-else-if="getComprehensive(scope.row, 'risk_level_type') === 'Sn_Level'" style="color:#909399; font-size:11px;">(S1~S5)</span>
                    <span v-else-if="getComprehensive(scope.row, 'risk_level_type') === 'Boolean'" style="color:#909399; font-size:11px;">(true/false)</span>
                  </el-descriptions-item>
                  <el-descriptions-item label="描述 (desc)" :span="2">{{ getComprehensive(scope.row, 'desc') || '-' }}</el-descriptions-item>
                </el-descriptions>
                <div style="font-size:11px; color:#909399; margin-top:4px;">
                  T1~T4: 低风险 · T5~T6: 中风险 · T7~T8: 高风险 · T9~T10: 极高风险 (长租)；S1~S3: 低风险 · S4: 中风险 · S5: 高风险 (短租)
                </div>
              </div>

              <div v-if="getRaw(scope.row, 'extremely_low_risk_models')" class="risk-expand-section">
                <div class="risk-expand-title">极低风险模型 (Extremely Low Risk)</div>
                <el-descriptions :column="2" border size="mini">
                  <el-descriptions-item label="风险级别">
                    <template v-if="getExtremelyLow(scope.row, 'risk_level') !== undefined && getExtremelyLow(scope.row, 'risk_level') !== null">
                      <el-tag size="mini" :type="String(getExtremelyLow(scope.row, 'risk_level')).toLowerCase() === 'true' ? 'success' : 'info'">
                        {{ String(getExtremelyLow(scope.row, 'risk_level')).toLowerCase() === 'true' || getExtremelyLow(scope.row, 'risk_level') === true ? '命中极低风险' : getExtremelyLow(scope.row, 'risk_level') }}
                      </el-tag>
                      <span style="color:#909399; font-size:11px; margin-left:4px;">{{ getExtremelyLow(scope.row, 'risk_level') }}</span>
                    </template>
                    <template v-else>-</template>
                  </el-descriptions-item>
                  <el-descriptions-item label="数据类型">{{ getExtremelyLow(scope.row, 'risk_level_type') || '-' }}</el-descriptions-item>
                  <el-descriptions-item label="描述" :span="2">{{ getExtremelyLow(scope.row, 'desc') || '-' }}</el-descriptions-item>
                </el-descriptions>
              </div>

              <div v-if="getRaw(scope.row, 'ship_goods_risk_models') && getRaw(scope.row, 'ship_goods_risk_models').length" class="risk-expand-section">
                <div class="risk-expand-title">发货建议 (Ship Goods Risk Models)</div>
                <el-table :data="getRaw(scope.row, 'ship_goods_risk_models')" size="mini" border stripe>
                  <el-table-column label="发货建议类型 (risk_code)" min-width="280">
                    <template slot-scope="s">
                      <div style="font-size:12px;">
                        <div style="font-weight:500;">{{ shipGoodsLabel(s.row.risk_code) }}</div>
                        <div style="color:#909399; font-size:11px;">{{ s.row.risk_code }}</div>
                      </div>
                    </template>
                  </el-table-column>
                  <el-table-column label="是否建议发货 (can_ship_flag)" width="200">
                    <template slot-scope="s">
                      <el-tag size="mini" :type="s.row.can_ship_flag === true ? 'success' : 'warning'">
                        {{ s.row.can_ship_flag === true ? 'true · 建议发货' : 'false · 综合评估' }}
                      </el-tag>
                    </template>
                  </el-table-column>
                </el-table>
              </div>

              <div v-if="getRaw(scope.row, 'consult_fail_reason') && getRaw(scope.row, 'consult_fail_reason').length" class="risk-expand-section">
                <div class="risk-expand-title">咨询失败原因 (Consult Fail Reason)</div>
                <el-table :data="getRaw(scope.row, 'consult_fail_reason')" size="mini" border stripe>
                  <el-table-column label="失败分类编码 (fail_code)" width="300">
                    <template slot-scope="s">
                      <div style="font-size:12px;">
                        <div style="font-weight:500;">{{ consultFailLabel(s.row.fail_code) }}</div>
                        <div style="color:#909399; font-size:11px;">{{ s.row.fail_code }}</div>
                      </div>
                    </template>
                  </el-table-column>
                  <el-table-column label="描述信息 (fail_message)">
                    <template slot-scope="s">
                      <span style="color:#E6A23C; font-size:12px;">{{ s.row.fail_message || '-' }}</span>
                    </template>
                  </el-table-column>
                </el-table>
              </div>

              <div class="risk-expand-section">
                <div class="risk-expand-title">原始响应 JSON</div>
                <pre class="risk-raw-json">{{ prettyJson(scope.row.rawResponse) }}</pre>
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="时间" width="150">
          <template slot-scope="scope">
            {{ scope.row.createdAt ? formatRiskTime(scope.row.createdAt) : '-' }}
          </template>
        </el-table-column>
        <el-table-column label="场景" width="95">
          <template slot-scope="scope">
            <el-tag size="mini" :type="consultTypeTag(scope.row.consultType)">
              {{ consultTypeLabel(scope.row.consultType) }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column label="结果" width="85">
          <template slot-scope="scope">
            <el-tag v-if="scope.row.errorMsg" size="mini" type="danger">失败</el-tag>
            <el-tag v-else-if="scope.row.pass === 1" size="mini" type="success">通过</el-tag>
            <el-tag v-else-if="scope.row.pass === 0" size="mini" type="warning">不通过</el-tag>
            <el-tag v-else-if="scope.row.resultCode" size="mini" :type="scope.row.resultCode === '10000' ? 'success' : 'danger'">
              {{ scope.row.resultCode }}
            </el-tag>
            <span v-else style="color: #909399;">-</span>
          </template>
        </el-table-column>
        <el-table-column label="风险概览" min-width="300">
          <template slot-scope="scope">
            <div v-if="getRiskData(scope.row)" style="line-height: 20px;">
              <div>
                <el-tag size="mini" :type="productEditionTag(getRaw(scope.row, 'product_edition'))" effect="plain">
                  {{ productEditionLabel(getRaw(scope.row, 'product_edition')) }}
                </el-tag>
                <el-tag v-if="getComprehensive(scope.row, 'risk_level')" size="mini" :type="comprehensiveLevelTag(scope.row)" effect="plain" style="margin-left:4px;">
                  综合 {{ getComprehensive(scope.row, 'risk_level') }}
                </el-tag>
                <el-tag v-if="getVertical(scope.row, 'mediary_risk_level')" size="mini" :type="verticalLevelTag('mediary', getVertical(scope.row, 'mediary_risk_level'))" effect="plain" style="margin-left:4px;">
                  中介 {{ riskLevelText(getVertical(scope.row, 'mediary_risk_level')) }}
                </el-tag>
              </div>
              <div v-if="getRiskInfos(scope.row).length" style="margin-top:2px;">
                <span v-for="ri in getRiskInfos(scope.row)" :key="ri.risk_type" style="font-size:11px; color:#606266;">
                  · {{ riskTypeLabel(ri.risk_type) }}
                </span>
              </div>
            </div>
            <span v-else-if="scope.row.errorMsg" style="color: #F56C6C; font-size:12px;">{{ scope.row.errorMsg }}</span>
            <span v-else-if="scope.row.resultDesc" style="color: #F56C6C; font-size:12px;">{{ scope.row.resultDesc }}</span>
            <span v-else style="color: #909399;">-</span>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="60" align="center">
          <template slot-scope="scope">
            <el-button type="text" size="mini" @click="copyRisk(scope.row)">复制</el-button>
          </template>
        </el-table-column>
      </el-table>

      <div v-if="riskHistory.length === 0 && !riskLoading" style="text-align: center; color: #909399; padding: 40px 0;">
        暂无风险咨询记录，点击右上角「新增咨询」开始
      </div>
      </div>

      <div slot="footer">
        <el-button @click="riskVisible = false">关 闭</el-button>
      </div>
    </el-dialog>

    <!-- 支付宝订单查询 -->
    <el-dialog
      title="支付宝订单详情"
      :visible.sync="alipayDialogVisible"
      width="750px"
      top="5vh"
    >
      <div v-loading="alipayLoading">
        <template v-if="alipayOrderData">
          <el-descriptions :column="2" border size="small">
            <el-descriptions-item label="支付宝订单号">{{ alipayOrderData.alipayOrderId }}</el-descriptions-item>
            <el-descriptions-item label="商户订单号">{{ alipayOrderData.outOrderId }}</el-descriptions-item>
            <el-descriptions-item label="订单类型">{{ alipayOrderData.orderType }}</el-descriptions-item>
            <el-descriptions-item label="支付宝状态">
              <el-tag size="mini">{{ alipayOrderData.status }}</el-tag>
            </el-descriptions-item>
            <el-descriptions-item label="订单标题">{{ alipayOrderData.title }}</el-descriptions-item>
            <el-descriptions-item label="创建时间">{{ alipayOrderData.orderCreateTime }}</el-descriptions-item>
          </el-descriptions>

          <!-- 金额信息 -->
          <div v-if="alipayOrderData.priceInfo" style="margin-top: 16px;">
            <el-descriptions :column="3" border size="small" title="金额信息">
              <el-descriptions-item label="订单总价">¥{{ alipayOrderData.priceInfo.order_price }}</el-descriptions-item>
              <el-descriptions-item label="押金">¥{{ alipayOrderData.priceInfo.deposit_price || '-' }}</el-descriptions-item>
              <el-descriptions-item label="运费">¥{{ alipayOrderData.priceInfo.freight || '0.00' }}</el-descriptions-item>
            </el-descriptions>
          </div>

          <!-- 分期信息 -->
          <div v-if="alipayOrderData.rentPlanInfo && alipayOrderData.rentPlanInfo.installments" style="margin-top: 16px;">
            <h4 style="margin-bottom: 8px;">租金分期计划</h4>
            <el-table :data="alipayOrderData.rentPlanInfo.installments" size="small" border stripe row-key="installment_no">
              <el-table-column label="期数" width="70" align="center">
              <template slot-scope="s">第{{ s.row.installment_no }}/共{{ alipayOrderData.rentPlanInfo.installments.length }}期</template>
            </el-table-column>
              <el-table-column prop="installment_price" label="租金" width="110" align="center">
                <template slot-scope="s">¥{{ s.row.installment_price }}</template>
              </el-table-column>
              <el-table-column prop="plan_pay_time" label="计划扣款日" width="170" align="center" />
              <el-table-column prop="buyout_price" label="买断价" width="110" align="center">
                <template slot-scope="s">
                  <span v-if="s.row.buyout_price">¥{{ s.row.buyout_price }}</span>
                  <span v-else>-</span>
                </template>
              </el-table-column>
            </el-table>
          </div>

          <!-- 签约信息 -->
          <div v-if="alipayOrderData.rentSignInfo" style="margin-top: 12px;">
            <div v-if="alipayOrderData.rentSignInfo.rent_deduct_info">
              <el-tag size="small" :type="alipayOrderData.rentSignInfo.rent_deduct_info.sign_status === 'SIGNED' ? 'success' : 'warning'">
                代扣: {{ alipayOrderData.rentSignInfo.rent_deduct_info.sign_status }}
              </el-tag>
            </div>
            <div v-if="alipayOrderData.rentSignInfo.fund_auth_freeze_info" style="margin-top: 6px;">
              <el-tag size="small" :type="alipayOrderData.rentSignInfo.fund_auth_freeze_info.sign_status === 'SIGNED' ? 'success' : 'warning'">
                预授权: {{ alipayOrderData.rentSignInfo.fund_auth_freeze_info.sign_status }}
              </el-tag>
              <span v-if="alipayOrderData.rentSignInfo.fund_auth_freeze_info.auth_no" style="margin-left: 8px; font-size: 12px; color: #909399;">
                {{ alipayOrderData.rentSignInfo.fund_auth_freeze_info.auth_no }}
              </span>
            </div>
          </div>
        </template>
      </div>

      <span slot="footer">
        <el-button @click="alipayDialogVisible = false">关闭</el-button>
      </span>
    </el-dialog>

    <el-dialog :title="'操作记录 · ' + (logOrder ? logOrder.orderNo : '')" :visible.sync="logVisible" width="680px" :close-on-click-modal="true">
      <div v-if="logLoading" style="text-align: center; padding: 40px; color: #909399;">
        <i class="el-icon-loading"></i> 加载中...
      </div>
      <div v-else-if="!logHistory || logHistory.length === 0" style="text-align: center; padding: 40px; color: #909399;">
        暂无操作记录
      </div>
      <el-timeline v-else style="padding: 16px 8px;">
        <el-timeline-item
          v-for="(item, index) in logHistory"
          :key="item.id"
          :timestamp="formatLogTime(item.createdAt)"
          :type="logType(item.action)"
          :icon="logIcon(item.action)"
          hollow
        >
          <div style="display: flex; align-items: center; gap: 8px;">
            <span style="font-weight: 600; color: #303133;">{{ item.actionDesc || item.action }}</span>
            <el-tag v-if="item.fromStatus" size="mini" style="margin-right: 4px;">{{ orderStatusLabel(item.fromStatus) }}</el-tag>
            <i v-if="item.fromStatus && item.toStatus" class="el-icon-arrow-right" style="color: #909399; font-size: 12px;"></i>
            <el-tag v-if="item.toStatus" size="mini" :type="logType(item.action) === 'success' ? 'success' : logType(item.action) === 'warning' ? 'warning' : logType(item.action) === 'danger' ? 'danger' : 'info'">{{ orderStatusLabel(item.toStatus) }}</el-tag>
          </div>
          <div v-if="item.remark" style="color: #606266; font-size: 12px; margin-top: 4px;">{{ item.remark }}</div>
          <div style="color: #909399; font-size: 12px; margin-top: 2px;">
            操作人：{{ item.operator || '-' }}（{{ item.operatorRole || '-' }}）
          </div>
        </el-timeline-item>
      </el-timeline>
      <span slot="footer">
        <el-button @click="logVisible = false">关闭</el-button>
      </span>
    </el-dialog>

    <el-dialog title="订单流程流转说明" :visible.sync="flowDescVisible" width="640px" :close-on-click-modal="true">
      <div style="line-height: 1.8; color: #606266; padding: 8px 12px;">
        <h4 style="color: #303133; margin: 0 0 12px 0;">订单状态流转图</h4>
        <div style="background: #F5F7FA; border-radius: 6px; padding: 14px 18px; font-family: Menlo, monospace; font-size: 13px; line-height: 2.2; color: #303133;">
<pre style="margin: 0; font-family: inherit;">
下单 → 待签约(WAIT_SIGN)
      ↓ 签约
待审核(WAIT_APPROVE)
      ↓ 审核通过
┌──────────────────────┴──────────────────────┐
▼                                              ▼
待合同签署(WAIT_CONTRACT) ← 长租              待发货(APPROVED) ← 短租
      ↓ 合同签署(e签宝回调)                    ↓ 发货(自提/快递)
待发货(APPROVED)                               待收货(DELIVERED)
      ↓ 发货(自提/快递)                        ↓ 确认收货
待收货(DELIVERED)                              租用中(RECEIVED/RENTING) ─┐
      ↓ 确认收货                               ↓ 用户寄回              │
租用中(RECEIVED/RENTING) ─┐                   已寄回(RETURN_DELIVERED)    │
      ↓ 用户寄回              │                ↓ 确认归还收货           │ 任何节点均可直接 → 已取消(CANCELLED)
已寄回(RETURN_DELIVERED)    │                   已归还收货(RETURN_RECEIVED)  │
      ↓ 确认归还收货           │                ↓ 完成                  │
已归还收货(RETURN_RECEIVED)  │                   已完成(FINISHED) ◄──────────┘
      ↓ 完成                  │
已完成(FINISHED) ◄──────────┘
</pre>
        </div>

        <h4 style="color: #303133; margin: 18px 0 10px 0;">各节点可执行操作</h4>
        <el-table :data="flowNodeTable" size="small" border stripe>
          <el-table-column prop="status" label="状态" width="140">
            <template slot-scope="scope">
              <el-tag size="mini" :type="getStatusType(scope.row.status)">{{ getStatusText(scope.row.status) }}</el-tag>
            </template>
          </el-table-column>
          <el-table-column prop="ops" label="可执行操作" min-width="320">
            <template slot-scope="scope">
              <span v-for="(op, i) in scope.row.ops" :key="i">
                <el-tag size="mini" :type="op.type" style="margin-right: 6px;">{{ op.label }}</el-tag>
              </span>
            </template>
          </el-table-column>
        </el-table>

        <h4 style="color: #303133; margin: 18px 0 10px 0;">风控（租安盾）时机</h4>
        <ul style="padding-left: 20px; margin: 0;">
          <li><b>发货后</b>：自动触发风控咨询（专业版 + 综合等级 + 发货建议 + 专项风险）</li>
          <li><b>确认收货后</b>：自动触发综合风控评估</li>
          <li><b>任意节点</b>：管理端可手动点击「风控」随时发起咨询</li>
        </ul>

        <h4 style="color: #303133; margin: 18px 0 10px 0;">支付与代扣</h4>
        <ul style="padding-left: 20px; margin: 0;">
          <li><b>主动支付</b>：小程序端用户在各租期「支付租金」唤起收银台支付首期</li>
          <li><b>代扣</b>：定时任务每天 10:00 / 17:00 扫描到期分期，使用预授权资金自动代扣</li>
          <li><b>线下付租</b>：管理端手动补录已支付分期（如线下转账、扫码等）</li>
        </ul>
      </div>
      <span slot="footer">
        <el-button @click="flowDescVisible = false">关闭</el-button>
      </span>
    </el-dialog>
  </div>
  <!-- e签宝同步结果弹窗 -->
  </el-dialog>

    <!-- 订单详情弹窗 -->
    <el-dialog title="订单详情" :visible.sync="detailVisible" width="680px" :close-on-click-modal="true">
      <el-descriptions v-if="detailOrder" :column="2" border size="small">
        <el-descriptions-item label="订单编号" :span="2">{{ detailOrder.orderNo }}</el-descriptions-item>
        <el-descriptions-item label="商户名称">{{ detailOrder.shopName || '-' }}</el-descriptions-item>
        <el-descriptions-item label="商品名称">{{ detailOrder.goodsName }}</el-descriptions-item>
        <el-descriptions-item label="租期类型">
          <el-tag size="mini" :type="detailOrder.rentType === 'LONG' ? 'danger' : 'info'">
            {{ detailOrder.rentType === 'LONG' ? '长租' : (detailOrder.rentType === 'SHORT' ? '短租' : '-') }}
          </el-tag>
        </el-descriptions-item>
        <el-descriptions-item label="租期(天)">{{ detailOrder.rentDays || '-' }}</el-descriptions-item>
        <el-descriptions-item label="订单金额" :span="2">¥{{ detailOrder.orderPrice }}</el-descriptions-item>
        <el-descriptions-item label="客户姓名">{{ detailOrder.tenantName }}</el-descriptions-item>
        <el-descriptions-item label="手机号">{{ detailOrder.tenantPhone }}</el-descriptions-item>
        <el-descriptions-item label="身份证号" :span="2">{{ detailOrder.tenantIdCard || '-' }}</el-descriptions-item>
        <el-descriptions-item label="订单状态">
          <el-tag :type="getStatusType(detailOrder.status)" size="small">{{ getStatusText(detailOrder.status) }}</el-tag>
        </el-descriptions-item>
        <el-descriptions-item label="创建时间">{{ detailOrder.createdAt }}</el-descriptions-item>
      </el-descriptions>
      <div slot="footer">
        <el-button @click="detailVisible = false">关 闭</el-button>
      </div>
    </el-dialog>
</template>

<script>
import { getOrderList, approveOrder, deliverOrder, receiveOrder, getOrderStatusCounts, cancelOrder, getOrderDetail, riskConsult, listRiskConsult, legalConsult, creditConsult, zuxianzhiConsult, getOrderInstallments, deductInstallment, offlinePay, getDeductionRecords, completeOrder, sendReturnOrder, receiveReturnOrder, alipayQueryOrder, listOrderLogs } from '@/api/order'
import { orderStatusMap, orderStatusTypeMap, getInstallmentStatusTag, getInstallmentStatusText, getPaymentStatusTag, getPaymentStatusText, getPayMethodTag, getPayMethodText, getConsultTypeText, getConsultTypeTag, getDeliveryTypeText } from '@common/statusMap.js'

export default {
  name: 'OrderList',
  data() {
    return {
      tableData: [],
      loading: false,
      query: {
        orderNo: '',
        tenantName: '',
        tenantPhone: '',
        tenantIdCard: '',
        status: 'ALL',
        dateRange: null
      },
      currentPage: 1,
      pageSize: 10,
      total: 0,
      deliverVisible: false,
      deliveringId: null,
      submitting: false,
      alipayDialogVisible: false,
      alipayLoading: false,
      alipayOrderData: null,
      logVisible: false,
      logLoading: false,
      logHistory: [],
      logOrder: null,
      deliverForm: {
        deliveryType: 'SELFPICK',
        deliveryCompany: '',
        waybillId: '',
        comment: ''
      },
      expressCompanies: [
        { id: 'SF', name: '顺丰速运' },
        { id: 'YTO', name: '圆通速递' },
        { id: 'ZTO', name: '中通快递' },
        { id: 'STO', name: '申通快递' },
        { id: 'YD', name: '韵达速递' },
        { id: 'JD', name: '京东物流' },
        { id: 'EMS', name: '邮政速递 EMS' },
        { id: 'DBL', name: '德邦快递' },
        { id: 'TTKD', name: '天天快递' },
        { id: 'ZT', name: '宅急送' },
        { id: 'OTHER', name: '其他' }
      ],
      rentPeriodVisible: false,
      rentPeriodOrder: null,
      snapshot: null,
      riskVisible: false,
      riskLoading: false,
      riskHistory: [],
      riskOrder: null,
      selectedRiskTypes: [],
      legalLoading: false,
      creditLoading: false,
      zuxianzhiLoading: false,
      flowDescVisible: false,
      flowNodeTable: [
        { status: 'WAIT_SIGN', ops: [{ label: '签约', type: 'success' }, { label: '取消', type: 'danger' }] },
        { status: 'SIGN_FAILED', ops: [{ label: '取消', type: 'danger' }] },
        { status: 'WAIT_APPROVE', ops: [{ label: '审核通过', type: '' }, { label: '取消', type: 'danger' }, { label: '风控', type: 'warning' }] },
        { status: 'WAIT_CONTRACT', ops: [{ label: '风控', type: 'warning' }] },
        { status: 'APPROVED', ops: [{ label: '发货', type: '' }, { label: '取消', type: 'danger' }, { label: '风控', type: 'warning' }] },
        { status: 'DELIVERED', ops: [{ label: '确认收货', type: 'success' }, { label: '取消', type: 'danger' }, { label: '风控', type: 'warning' }] },
        { status: 'RECEIVED', ops: [{ label: '用户寄回', type: 'warning' }, { label: '风控', type: 'warning' }] },
        { status: 'RENTING', ops: [{ label: '用户寄回', type: 'warning' }, { label: '代扣', type: 'info' }, { label: '风控', type: 'warning' }] },
        { status: 'RETURN_DELIVERED', ops: [{ label: '确认归还收货', type: 'success' }, { label: '风控', type: 'warning' }] },
        { status: 'RETURN_RECEIVED', ops: [{ label: '完成', type: 'success' }, { label: '风控', type: 'warning' }] },
        { status: 'FINISHED', ops: [{ label: '风控', type: 'warning' }] },
        { status: 'CANCELLED', ops: [] }
      ],
      // 分期扣款
      installmentData: [],
      installmentLoading: false,
      // 线下付租
      offlinePayVisible: false,
      offlinePaySubmitting: false,
      offlinePayForm: { installmentNo: 1, amount: 0, payChannel: 'ALIPAY', tradeNo: '' },
      // 扣款记录
      deductionRecordVisible: false,
      deductionRecordLoading: false,
      deductionRecordData: [],
      deductionInstNo: 1,
      deductionInstTotal: 0,
      detailVisible: false,
      detailOrder: null,
      statusCounts: {
        WAIT_SIGN: 0,
        WAIT_APPROVE: 0,
        APPROVED: 0,
        DELIVERED: 0,
        RECEIVED: 0,
        RENTING: 0,
        FINISHED: 0,
        CANCELLED: 0
      }
    }
  },
  computed: {
    isPlatformAdmin() {
      const userInfo = JSON.parse(localStorage.getItem('userInfo') || '{}')
      return userInfo.role === 'PLATFORM'
    },
    statusTabs() {
      return [
        { label: '全部', name: 'ALL' },
        { label: `待签约(${this.statusCounts.WAIT_SIGN || 0})`, name: 'WAIT_SIGN' },
        { label: `待审核(${this.statusCounts.WAIT_APPROVE || 0})`, name: 'WAIT_APPROVE' },
        { label: `待合同签署(${this.statusCounts.WAIT_CONTRACT || 0})`, name: 'WAIT_CONTRACT' },
        { label: `待发货(${this.statusCounts.APPROVED || 0})`, name: 'APPROVED' },
        { label: `待收货(${this.statusCounts.DELIVERED || 0})`, name: 'DELIVERED' },
        { label: `租用中(${
            (this.statusCounts.RECEIVED || 0) +
            (this.statusCounts.RENTING || 0) +
            (this.statusCounts.RETURN_DELIVERED || 0) +
            (this.statusCounts.RETURN_RECEIVED || 0)
        })`, name: 'RENTING_MIXED' },
        { label: `已完成(${this.statusCounts.FINISHED || 0})`, name: 'FINISHED' },
        { label: `已取消(${this.statusCounts.CANCELLED || 0})`, name: 'CANCELLED' }
      ]
    }
  },
  created() {
    this.loadData()
    this.loadStatusCounts()
  },
  methods: {
    async loadStatusCounts() {
      try {
        const res = await getOrderStatusCounts()
        if (res.data) {
          this.statusCounts = {
            WAIT_SIGN: res.data.WAIT_SIGN || 0,
            WAIT_CONTRACT: res.data.WAIT_CONTRACT || 0,
            WAIT_APPROVE: res.data.WAIT_APPROVE || 0,
            APPROVED: res.data.APPROVED || 0,
            DELIVERED: res.data.DELIVERED || 0,
            RECEIVED: res.data.RECEIVED || 0,
            RENTING: res.data.RENTING || 0,
            FINISHED: res.data.FINISHED || 0,
            CANCELLED: res.data.CANCELLED || 0
          }
        }
      } catch (e) {
        console.error(e)
      }
    },
    async loadData() {
      this.loading = true
      try {
        const params = {
          page: this.currentPage,
          size: this.pageSize
        }
        if (this.query.orderNo) params.orderNo = this.query.orderNo
        if (this.query.tenantName) params.tenantName = this.query.tenantName
        if (this.query.tenantPhone) params.tenantPhone = this.query.tenantPhone
        if (this.query.tenantIdCard) params.tenantIdCard = this.query.tenantIdCard
        if (this.query.status && this.query.status !== 'ALL') {
          if (this.query.status === 'RENTING_MIXED') {
            params.statusIn = 'RECEIVED,RENTING,RETURN_DELIVERED,RETURN_RECEIVED'
          } else {
            params.status = this.query.status
          }
        }
        if (this.query.dateRange && this.query.dateRange.length === 2) {
          params.startDate = this.query.dateRange[0]
          params.endDate = this.query.dateRange[1]
        }
        const res = await getOrderList(params)
        if (res.data && res.data.records) {
          this.tableData = res.data.records
          this.total = res.data.total || 0
        }
        // 标记租用中订单初始状态（分期数据加载前隐藏按钮）
        this.tableData.filter(r => ['RECEIVED', 'RENTING'].includes(r.status)).forEach(r => {
          this.$set(r, '_installmentData', null)
        })
        // 异步加载租用中订单的分期状态（用于控制用户寄回按钮显示）
        const rentRows = this.tableData.filter(r => ['RECEIVED', 'RENTING'].includes(r.status))
        for (const row of rentRows) {
          try {
            const instRes = await getOrderInstallments(row.id)
            const insts = instRes.data || []
            this.$set(row, '_installmentData', insts)
          } catch (e) { /* 静默 */ }
        }
      } catch (e) {
        console.error(e)
      } finally {
        this.loading = false
      }
    },
    handleTabClick(tab) {
      this.query.status = tab.name
      this.currentPage = 1
      this.loadData()
    },
    handleSearch() {
      this.currentPage = 1
      this.loadData()
    },
    handleReset() {
      this.query = {
        orderNo: '',
        tenantName: '',
        tenantPhone: '',
        tenantIdCard: '',
        status: 'ALL',
        dateRange: null
      }
      this.currentPage = 1
      this.loadData()
    },
    async showInstallment(row) {
      try {
        const res = await getOrderInstallments(row.id)
        if (res.data) {
          this.installmentData = (res.data || []).map(item => ({
            ...item,
            _deducting: false
          }))
        }
      } catch (e) {
        this.$message.error(e.message || '加载分期失败')
      } finally {
        this.installmentLoading = false
      }
    },
    onRentPeriodClose() {
      this.installmentData = []
      this.rentPeriodOrder = null
      this.snapshot = null
    },
    async handleDeductClick(row) {
      try {
        await this.$confirm(`确认对第${row.installmentNo}/共${this.installmentData.length}期发起租金扣款 (¥${row.installmentPrice})？`, '租金扣款', { type: 'info' })
      } catch (e) {
        return
      }
      row._deducting = true
      try {
        const res = await deductInstallment(this.rentPeriodOrder.id, {
          installmentNo: row.installmentNo,
          amount: row.installmentPrice
        })
        this.$message.success('扣款请求已发起，等待支付宝处理')
        await this.loadInstallments()
      } catch (e) {
        this.$message.error(e.message || '扣款失败')
      } finally {
        row._deducting = false
      }
    },
    handleOfflinePayClick(row) {
      this.offlinePayForm = {
        installmentNo: row.installmentNo,
        amount: row.installmentPrice,
        payChannel: 'OTHER',
        tradeNo: ''
      }
      this.offlinePayVisible = true
    },
    async confirmOfflinePay() {
      const f = this.offlinePayForm
      if (!f.payChannel) {
        this.$message.error('请选择支付渠道')
        return
      }
      if (f.payChannel === 'ALIPAY' && (!f.tradeNo || !f.tradeNo.trim())) {
        this.$message.error('支付宝渠道必须填写支付单号')
        return
      }
      this.offlinePaySubmitting = true
      try {
        const payload = {
          installmentNo: f.installmentNo,
          amount: f.amount,
          payChannel: f.payChannel
        }
        if (f.tradeNo) payload.tradeNo = f.tradeNo.trim()
        await offlinePay(this.rentPeriodOrder.id, payload)
        this.$message.success('线下付租同步成功')
        this.offlinePayVisible = false
        await this.loadInstallments()
      } catch (e) {
        this.$message.error(e.message || '同步失败')
      } finally {
        this.offlinePaySubmitting = false
      }
    },
    async handleDeductionRecords(row) {
      this.deductionInstNo = row.installmentNo
      this.deductionRecordData = []
      this.deductionRecordVisible = true
      this.deductionRecordLoading = true
      try {
        const res = await getDeductionRecords(this.rentPeriodOrder.id, row.installmentNo)
        this.deductionRecordData = (res && res.data) || []
      } catch (e) {
        this.$message.error(e.message || '加载失败')
      } finally {
        this.deductionRecordLoading = false
      }
    },
    async loadInstallments() {
      if (!this.rentPeriodOrder) return
      try {
        const res = await getOrderInstallments(this.rentPeriodOrder.id)
        if (res.data) {
          this.installmentData = (res.data || []).map(item => ({
            ...item,
            _deducting: false
          }))
        }
      } catch (e) {
        console.error(e)
      }
    },
    instStatusTag(status) {
      return getInstallmentStatusTag(status)
    },
    instStatusText(status) {
      return getInstallmentStatusText(status)
    },
    payMethodTag(method) {
      return getPayMethodTag(method)
    },
    payMethodText(method) {
      return getPayMethodText(method)
    },
    payStatusTag(status) {
      return getPaymentStatusTag(status)
    },
    payStatusText(status) {
      return getPaymentStatusText(status)
    },
    async handleAction(row, action) {
      if (action === 'approve') {
        try {
          await this.$confirm('确认审核通过该订单？', '提示', { type: 'info' })
          await approveOrder(row.id)
          this.$message.success('审核成功')
          this.loadData()
          this.loadStatusCounts()
        } catch (e) {
          if (e !== 'cancel') console.error(e)
        }
      } else if (action === 'deliver') {
        this.deliveringId = row.id
        this.deliverForm = {
          deliveryType: 'SELFPICK',
          deliveryCompany: '',
          waybillId: '',
          comment: ''
        }
        this.deliverVisible = true
      } else if (action === 'receive') {
        try {
          await this.$confirm('确认该订单已收货？', '确认收货', { type: 'warning' })
          await receiveOrder(row.id)
          this.$message.success('收货成功')
          this.loadData()
          this.loadStatusCounts()
        } catch (e) {
          if (e !== 'cancel') this.$message.error(e.message || '收货失败')
        }
      } else if (action === 'cancel') {
        try {
          await this.$confirm('确认取消该订单？', '提示', { type: 'warning' })
          await cancelOrder(row.id, '管理员取消')
          this.$message.success('已取消')
          this.loadData()
          this.loadStatusCounts()
        } catch (e) {
          if (e !== 'cancel') console.error(e)
        }
      }
    },
    async confirmDeliver() {
      const f = this.deliverForm

      if (!f.deliveryType) {
        this.$message.error('请选择发货方式')
        return
      }
      if (f.deliveryType === 'EXPRESS') {
        if (!f.deliveryCompany) {
          this.$message.error('请选择快递公司')
          return
        }
        if (!f.waybillId || !f.waybillId.trim()) {
          this.$message.error('请输入快递单号')
          return
        }
      }

      this.submitting = true
      try {
        const payload = {
          deliveryType: f.deliveryType
        }
        if (f.deliveryType === 'EXPRESS') {
          payload.deliveryCompany = f.deliveryCompany
          payload.waybillId = f.waybillId.trim()
        }
        await deliverOrder(this.deliveringId, payload)
        this.$message.success('发货成功')
        this.deliverVisible = false
        this.loadData()
        this.loadStatusCounts()
      } catch (e) {
        this.$message.error(e.message || '发货失败')
      } finally {
        this.submitting = false
      }
    },
    canCancel(status) {
      const cancellable = ['WAIT_SIGN', 'SIGN_FAILED', 'WAIT_APPROVE', 'WAIT_CONTRACT', 'APPROVED', 'DELIVERED']
      return cancellable.includes(status)
    },
    canComplete(status) {
      return ['RECEIVED', 'RENTING', 'RETURN_DELIVERED', 'RETURN_RECEIVED'].includes(status)
    },
    canReturn(row) {
      if (!['RECEIVED', 'RENTING'].includes(row.status)) return false
      if (row._installmentData === null) return false
      if (!row._installmentData || row._installmentData.length === 0) return true
      return !row._installmentData.some(inst => inst.status === 'UNPAID' || inst.status === 'INIT')
    },
    canReceiveReturn(status) {
      return status === 'RETURN_DELIVERED'
    },
    canFinish(status) {
      return status === 'RETURN_RECEIVED'
    },
    async handleComplete(row) {
      try {
        await this.$confirm('确认完成该订单？将依次执行：用户寄回 → 商家确认收货 → 完结订单。请确保所有租金已支付完毕。', '完成订单', { type: 'warning', confirmButtonText: '确认完成' })
      } catch (e) {
        return
      }
      this.submitting = true
      try {
        await completeOrder(row.id)
        this.$message.success('订单已完成')
        this.loadData()
        this.loadStatusCounts()
      } catch (e) {
        this.$message.error(e.message || '完成订单失败')
      } finally {
        this.submitting = false
      }
    },
    async handleReturn(row) {
      try {
        await this.$confirm('确认用户已寄回商品？系统将调用支付宝完成用户寄回履约。', '用户寄回', { type: 'info' })
      } catch (_) {
        return
      }
      try {
        await sendReturnOrder(row.id)
        this.$message.success('用户寄回成功')
        this.loadData()
        this.loadStatusCounts()
      } catch (e) {
        this.$message.error(e.message || '操作失败')
      }
    },
    async handleReceiveReturn(row) {
      try {
        await this.$confirm('确认已收到用户归还的商品？系统将调用支付宝完成商家收货履约。', '确认归还收货', { type: 'warning' })
      } catch (_) {
        return
      }
      try {
        await receiveReturnOrder(row.id)
        this.$message.success('归还收货成功')
        this.loadData()
        this.loadStatusCounts()
      } catch (e) {
        this.$message.error(e.message || '操作失败')
      }
    },
    async handleFinish(row) {
      try {
        await this.$confirm('确认完结该订单？请确保所有租金已支付完毕。', '完成订单', { type: 'warning', confirmButtonText: '确认完成' })
      } catch (_) {
        return
      }
      try {
        await completeOrder(row.id)
        this.$message.success('订单已完成')
        this.loadData()
        this.loadStatusCounts()
      } catch (e) {
        this.$message.error(e.message || '完成订单失败')
      }
    },
    async handleAlipayQuery(row) {
      this.alipayDialogVisible = true
      this.alipayLoading = true
      this.alipayOrderData = null
      try {
        const res = await alipayQueryOrder(row.id)
        this.alipayOrderData = res.data || res
      } catch (e) {
        this.$message.error(e.message || '查询支付宝订单失败')
      } finally {
        this.alipayLoading = false
      }
    },
    canRiskConsult() {
      return true
    },
    async showOrderLogs(row) {
      this.logOrder = row
      this.logHistory = []
      this.logVisible = true
      this.logLoading = true
      try {
        const res = await listOrderLogs(row.id)
        const list = (res && res.data) || []
        this.logHistory = list.slice().sort((a, b) => {
          const ta = a.createdAt ? new Date(a.createdAt).getTime() : 0
          const tb = b.createdAt ? new Date(b.createdAt).getTime() : 0
          return tb - ta
        })
      } catch (e) {
        this.$message.error(e.message || '加载操作记录失败')
      } finally {
        this.logLoading = false
      }
    },
    logType(action) {
      if (!action) return 'info'
      if (['CREATE', 'APPROVE', 'DELIVER', 'CONFIRM_RECEIVE', 'FINISH', 'COMPLETE', 'RISK_CONSULT', 'PAY_NOTIFY'].includes(action)) return 'success'
      if (['SEND_RETURN', 'RECEIVE_RETURN', 'DEDUCT', 'INIT_PAY', 'OFFLINE_PAY'].includes(action)) return 'warning'
      if (['CANCEL', 'SIGN', 'PAY_CLOSED'].includes(action)) return 'danger'
      return 'info'
    },
    logIcon(action) {
      if (!action) return 'el-icon-info'
      if (action === 'CREATE') return 'el-icon-plus'
      if (action === 'APPROVE') return 'el-icon-circle-check'
      if (action === 'DELIVER') return 'el-icon-s-promotion'
      if (action === 'CONFIRM_RECEIVE') return 'el-icon-message-solid'
      if (action === 'SEND_RETURN') return 'el-icon-position'
      if (action === 'RECEIVE_RETURN') return 'el-icon-place'
      if (action === 'FINISH' || action === 'COMPLETE') return 'el-icon-finished'
      if (action === 'CANCEL') return 'el-icon-circle-close'
      if (action === 'SIGN') return 'el-icon-edit-outline'
      if (action === 'RISK_CONSULT') return 'el-icon-warning'
      if (action === 'DEDUCT') return 'el-icon-wallet'
      if (action === 'INIT_PAY' || action === 'OFFLINE_PAY' || action === 'PAY_NOTIFY') return 'el-icon-coin'
      if (action === 'PAY_CLOSED') return 'el-icon-circle-close'
      return 'el-icon-info'
    },
    formatLogTime(time) {
      if (!time) return '-'
      return String(time).replace('T', ' ').replace(/\..*$/, '')
    },
    orderStatusLabel(status) {
      return orderStatusMap[status] || status || '-'
    },
    handleDetail(row) {
      this.detailOrder = row
      this.detailVisible = true
    },
    handleRentPeriod(row) {
      this.rentPeriodOrder = row
      this.installmentData = []
      this.installmentLoading = true
      this.rentPeriodVisible = true
      this.showInstallment(row)
    },
    async handleRiskConsult(row) {
      if (!row || !row.id) {
        this.$message.warning('订单信息不完整，请刷新后重试')
        return
      }
      this.riskOrder = row
      this.riskHistory = []
      this.riskVisible = true
      this.riskLoading = true
      try {
        const res = await listRiskConsult(row.id)
        this.riskHistory = (res && res.data) || []
      } catch (e) {
        this.$message.error(e.message || '加载历史失败')
      } finally {
        this.riskLoading = false
      }
    },
    async doRiskConsult() {
      if (!this.riskOrder) return
      this.riskLoading = true
      try {
        // 传递选中的风控类型，如果未选择则默认查全部
        const consultRiskTypes = this.selectedRiskTypes.length > 0 ? this.selectedRiskTypes : null
        const res = await riskConsult(this.riskOrder.id, consultRiskTypes)
        const newRecord = (res && res.data) || {}
        this.riskHistory.unshift(newRecord)
        this.$message.success('租安盾咨询完成')
      } catch (e) {
        this.$message.error(e.message || '风险咨询失败')
      } finally {
        this.riskLoading = false
      }
    },
    async doLegalConsult() {
      if (!this.riskOrder || !this.riskOrder.id) return
      this.legalLoading = true
      try {
        const res = await legalConsult(this.riskOrder.id)
        this.riskHistory.unshift(res.data || res)
        this.$message.success('人法查询成功')
      } catch (e) {
        this.$message.error(e.message || '人法查询失败')
      } finally {
        this.legalLoading = false
      }
    },
    async doCreditConsult() {
      if (!this.riskOrder || !this.riskOrder.id) return
      this.creditLoading = true
      try {
        const res = await creditConsult(this.riskOrder.id)
        this.riskHistory.unshift(res.data || res)
        this.$message.success('征信查询成功')
      } catch (e) {
        this.$message.error(e.message || '征信查询失败')
      } finally {
        this.creditLoading = false
      }
    },
    async doZuxianzhiConsult() {
      if (!this.riskOrder || !this.riskOrder.id) return
      this.zuxianzhiLoading = true
      try {
        const res = await zuxianzhiConsult(this.riskOrder.id)
        this.riskHistory.unshift(res.data || res)
        this.$message.success('租先知查询成功')
      } catch (e) {
        this.$message.error(e.message || '租先知查询失败')
      } finally {
        this.zuxianzhiLoading = false
      }
    },
    formatRiskTime(val) {
      if (!val) return '-'
      if (typeof val === 'string') return val.replace('T', ' ').slice(0, 19)
      return val
    },
    onRiskDialogClose() {
      this.riskHistory = []
      this.riskOrder = null
    },
    consultTypeLabel(type) {
      return getConsultTypeText(type)
    },
    consultTypeTag(type) {
      return getConsultTypeTag(type)
    },
    riskLevelTag(level) {
      if (level == null || level === undefined) return 'info'
      const lv = String(level).toLowerCase()
      if (lv.includes('sup') || lv.includes('high') || lv.includes('r3') || lv.includes('r4') || lv.includes('r5') || lv.includes('r6')) return 'danger'
      if (lv.includes('mid') || lv.includes('medium') || lv.includes('r2')) return 'warning'
      if (lv.includes('low') || lv.includes('nor') || lv.includes('normal') || lv.includes('r0') || lv.includes('r1')) return 'success'
      if (lv === '5') return 'success'
      if (lv === '4') return 'success'
      if (lv === '3') return 'success'
      if (lv === '2') return 'warning'
      if (lv === '1') return 'warning'
      if (lv === '0') return 'danger'
      return 'info'
    },
    riskItemLevelTag(level) {
      if (level == null) return 'info'
      const lv = String(level).toLowerCase()
      if (lv === 'sup' || lv === 'high') return 'danger'
      if (lv === 'mid') return 'warning'
      if (lv === 'low' || lv === 'nor') return 'success'
      return 'info'
    },
    riskLevelText(level) {
      if (level == null) return ''
      const map = { sup: '超高风险', high: '高风险', mid: '中风险', low: '低风险', nor: '无' }
      return map[String(level).toLowerCase()] || level
    },
    verticalLevelTag(type, level) {
      if (level == null || level === undefined) return 'info'
      const lv = String(level).toLowerCase()
      if (type === 'mediary') {
        if (lv === 'high') return 'danger'
        if (lv === 'mid') return 'warning'
        if (lv === 'low') return 'success'
      }
      if (type === 'ongoing') {
        if (lv === 'mid') return 'warning'
        if (lv === 'low' || lv === 'nor') return 'success'
      }
      if (type === 'fulfillment') {
        const n = parseInt(lv, 10)
        if (isNaN(n)) return 'info'
        if (n >= 3) return 'success'
        if (n === 2) return 'warning'
        if (n <= 1) return 'danger'
      }
      return 'info'
    },
    comprehensiveLevelTag(row) {
      const d = this.getRiskData(row)
      if (!d || !d.comprehensive_risk_models) return 'info'
      const level = d.comprehensive_risk_models.risk_level
      const type = d.comprehensive_risk_models.risk_level_type
      if (!level) return 'info'
      const lv = String(level).toLowerCase()
      if (type === 'Tn_Level') {
        if (['t9','t10'].includes(lv)) return 'danger'
        if (['t7','t8'].includes(lv)) return 'danger'
        if (['t5','t6'].includes(lv)) return 'warning'
        if (['t1','t2','t3','t4'].includes(lv)) return 'success'
      }
      if (type === 'Sn_Level') {
        if (lv === 's5') return 'danger'
        if (lv === 's4') return 'warning'
        if (['s1','s2','s3'].includes(lv)) return 'success'
      }
      return this.riskLevelTag(level)
    },
    tailoredRiskLevelTag(level) {
      if (!level) return 'info'
      const lv = String(level).toLowerCase()
      // D1~D10 等级划分
      if (['d9','d10'].includes(lv)) return 'danger'
      if (['d7','d8'].includes(lv)) return 'danger'
      if (['d4','d5','d6'].includes(lv)) return 'warning'
      if (['d1','d2','d3'].includes(lv)) return 'success'
      return 'info'
    },
    comprehensiveDesc(row) {
      const d = this.getRiskData(row)
      if (!d || !d.comprehensive_risk_models) return ''
      const desc = d.comprehensive_risk_models.desc
      return desc ? `(${desc})` : ''
    },
    productEditionLabel(v) {
      if (v === 'BASIC') return '租安盾基础版'
      if (v === 'PRO') return '租安盾专业版'
      return v || '租安盾'
    },
    productEditionTag(v) {
      if (v === 'PRO') return 'danger'
      return 'info'
    },
    vamGroupLabel(v) {
      if (v === 'experimental') return '实验组'
      if (v === 'control') return '对照组'
      return v
    },
    ongoingLabel(v) {
      if (v === 'nor') return '无在租'
      if (v === 'low') return '低风险'
      if (v === 'mid') return '中风险'
      return v
    },
    policyValueLabel(v) {
      const map = {
        zhimazulin_zuandun_short_rent: '短租策略',
        zhimazulin_zuandun_short_campaign: '免审必发',
        zhiAnDun: '免押租安盾',
        zhimazulin_zuandun: '长租策略'
      }
      return map[v] || v
    },
    getPolicyValue(row) {
      const d = this.getRiskData(row)
      if (!d || !d.risk_basic_info) return null
      return this.policyValueLabel(d.risk_basic_info.risk_policy_value) || d.risk_basic_info.risk_policy_value
    },
    getVerticalModels(row) {
      const d = this.getRiskData(row)
      return d ? d.vertical_risk_models : null
    },
    getExtremelyLow(row) {
      const d = this.getRiskData(row)
      return d ? d.extremely_low_risk_models : null
    },
    riskTypeLabel(t) {
      const map = { CONCURRENT_RENT: '共租风险', COMPREHENSIVE_RISK: '综合风险', SHIP_GOODS_RISK: '发货风险', VERTICAL_RENT_RISK: '租赁专项' }
      return map[t] || t || ''
    },
    riskCodeLabel(c) {
      const map = {
        ORDER_CONCURRENT_RENT_RISK: '订单维度共租风险',
        ACCOUNT_RENT_APPLY_CNT_T0: '当日申请商家数',
        ACCOUNT_RENT_APPLY_CNT_T7: '7日申请商家数',
        ZHIMA_LONG_RENT_SHIP_GOODS_RISK: '阵地长租发货标',
        ZHIMA_SHORT_RENT_SHIP_GOODS_RISK: '阵地短租发货标',
        MEDIARY_RISK: '中介风险'
      }
      return map[c] || c || ''
    },
    shipGoodsLabel(c) {
      if (c === 'ZHIMA_LONG_RENT_SHIP_GOODS_RISK') return '长租'
      if (c === 'ZHIMA_SHORT_RENT_SHIP_GOODS_RISK') return '短租'
      return '发货'
    },
    consultFailLabel(c) {
      const map = {
        comprehensive_risk_null_reason: '综合风险等级为空',
        ship_goods_risk_null_reason: '发货标为空',
        order_concurrent_rent_risk_null_reason: '共租风险等级为空'
      }
      return map[c] || c || '咨询失败'
    },
    parseRiskRaw(raw) {
      if (!raw) return null
      let obj = null
      if (typeof raw === 'string') {
        try { obj = JSON.parse(raw) } catch (e) { return null }
      } else if (typeof raw === 'object') {
        obj = raw
      } else {
        return null
      }
      if (!obj) return null
      if (obj.data && typeof obj.data === 'object' && !Array.isArray(obj.data)) {
        if (obj.data.data && typeof obj.data.data === 'object') return obj.data.data
        return obj.data
      }
      if (obj.alipay_commerce_rent_risk_consult_response && typeof obj.alipay_commerce_rent_risk_consult_response === 'object') {
        const inner = obj.alipay_commerce_rent_risk_consult_response
        if (inner.data && typeof inner.data === 'object') return inner.data
        return inner
      }
      if (obj.code && obj.msg && typeof obj.code === 'string') {
        if (obj.data && typeof obj.data === 'object') return obj.data
        return obj
      }
      return obj
    },
    getRiskData(row) {
      if (!row) return null
      return this.parseRiskRaw(row.rawResponse)
    },
    getRaw(row, key) {
      const d = this.getRiskData(row)
      return d ? d[key] : null
    },
    getBasic(row, key) {
      const d = this.getRiskData(row)
      return d && d.risk_basic_info ? d.risk_basic_info[key] : null
    },
    getVertical(row, key) {
      const d = this.getRiskData(row)
      if (!d || !d.vertical_risk_models) return key ? null : d ? d.vertical_risk_models : null
      return d.vertical_risk_models[key]
    },
    getComprehensive(row, key) {
      const d = this.getRiskData(row)
      if (!d || !d.comprehensive_risk_models) return key ? null : null
      return d.comprehensive_risk_models[key]
    },
    getExtremelyLow(row, key) {
      const d = this.getRiskData(row)
      if (!d || !d.extremely_low_risk_models) return key ? null : null
      return d.extremely_low_risk_models[key]
    },
    getRiskInfos(row) {
      const d = this.getRiskData(row)
      return d && Array.isArray(d.risk_infos) ? d.risk_infos : []
    },
    getShipGoodsList(row) {
      const d = this.getRiskData(row)
      return d && Array.isArray(d.ship_goods_risk_models) ? d.ship_goods_risk_models : []
    },
    getConsultFails(row) {
      const d = this.getRiskData(row)
      return d && Array.isArray(d.consult_fail_reason) ? d.consult_fail_reason : []
    },
    getProductEdition(row) {
      return this.getRaw(row, 'product_edition')
    },
    getVamGroup(row) {
      return this.getRaw(row, 'vam_group')
    },
    getComprehensiveLevel(row) {
      return this.getComprehensive(row, 'risk_level')
    },
    prettyJson(raw) {
      if (!raw) return '-'
      let obj = null
      if (typeof raw === 'string') {
        try { obj = JSON.parse(raw) } catch (e) { return raw }
      } else if (typeof raw === 'object') {
        obj = raw
      } else {
        return String(raw)
      }
      return JSON.stringify(obj, null, 2)
    },
    async copyRisk(row) {
      if (!row) return
      const text = this.prettyJson(row.rawResponse)
      try {
        if (navigator.clipboard) {
          await navigator.clipboard.writeText(text || '')
        } else {
          const ta = document.createElement('textarea')
          ta.value = text || ''
          document.body.appendChild(ta)
          ta.select()
          document.execCommand('copy')
          document.body.removeChild(ta)
        }
        this.$message.success('已复制到剪贴板')
      } catch (e) {
        this.$message.error('复制失败')
      }
    },
    formatTime(time) {
      if (!time) return '-'
      return time.replace('T', ' ').substring(0, 19)
    },
    getStatusType(status) {
      return orderStatusTypeMap[status] || 'info'
    },
    getStatusText(status) {
      return orderStatusMap[status] || status
    }
  }
}
</script>

<style scoped>
.page-container {
  animation: fadeIn 0.3s ease;
}

@keyframes fadeIn {
  from { opacity: 0; transform: translateY(10px); }
  to { opacity: 1; transform: translateY(0); }
}

.status-tabs {
  margin-bottom: 16px;
}

.toolbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 12px;
}

.toolbar-left {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;
}

.pagination-wrapper {
  margin-top: 16px;
  display: flex;
  justify-content: flex-end;
}

.risk-expand-wrap {
  padding: 4px 2px;
}

.risk-expand-section {
  margin-bottom: 10px;
  background: #fafafa;
  border: 1px solid #ebeef5;
  border-radius: 4px;
  padding: 8px 10px;
}

.risk-expand-title {
  font-size: 12px;
  font-weight: 600;
  color: #303133;
  margin-bottom: 6px;
  padding-bottom: 4px;
  border-bottom: 1px dashed #e4e7ed;
}

.risk-raw-json {
  background: #1e1e1e;
  color: #d4d4d4;
  font-size: 11px;
  line-height: 1.5;
  padding: 10px 12px;
  border-radius: 4px;
  overflow-x: auto;
  max-height: 300px;
  white-space: pre-wrap;
  word-break: break-all;
  margin: 0;
}
</style>
